module.exports = __webpack_public_path__ + "img/thumbtack-solid.4ae0b977.svg";